export class TotpEnroll {
  constructor(init: Partial<TotpEnroll> = {}) {
    this.totpSecret = init.totpSecret || ''
    this.issuer = init.issuer || ''
    this.accountName = init.accountName || ''
    this.otpauthUri = init.otpauthUri || ''
    this.otp = init.otp || ''
    this.challengeToken = init.challengeToken || ''
  }

  totpSecret: string
  issuer: string
  accountName: string
  otpauthUri: string
  otp: string
  challengeToken: string
}
